// Generated by CoffeeScript 1.12.7
require.config({
  baseUrl: '/javascript/libs',
  enforceDefine: false,
  waitSeconds: 120,
  paths: {
    collections: '../collections',
    etc: '../etc',
    models: '../models',
    views: '../views',
    templates: '../../templates',
    underscore: 'lodash',
    cloudinary: 'cloudinary/cloudinary-core-shrinkwrap',
    text: 'require_plugins/text',
    propertyParser: 'require_plugins/propertyParser'
  }
});

define('../main',['require','jquery','underscore','views/survey_view','base64','sp/ui/alert','raven'],function(require) {
  var $, Alert, Base64, Raven, SurveyView, _, init;
  window.DEBUG = false;
  if (!window.console) {
    window.console = {
      log: function() {},
      error: function() {}
    };
  }
  $ = require('jquery');
  _ = require('underscore');
  SurveyView = require("views/survey_view");
  Base64 = require('base64');
  Alert = require('sp/ui/alert');
  Raven = require('raven');
  Raven.config(GLOBALS.publicKeys.sentry, {
    environment: GLOBALS.env,
    release: GLOBALS.version,
    logger: 'javascript'
  }).install();
  init = function(data) {
    var language, surveyView;
    surveyView = new SurveyView({
      data: data,
      version: GLOBALS.version,
      env: GLOBALS.env
    });
    language = _.get(data, ['language', 'code']);
    surveyView.on(SurveyView.UNAVAILABLE_EVENT, function() {
      surveyView.destroyListeners();
      return window.location.href = "/unavailable?lang=" + language;
    });
    surveyView.on(SurveyView.FORBIDDEN_EVENT, function() {
      surveyView.destroyListeners();
      return window.location.href = "/completed?lang=" + language;
    });
    return surveyView.render();
  };
  return $(document).ready(function() {
    var $encoded, data, encodedData, err;
    $encoded = $('#encoded');
    encodedData = $encoded.data('src');
    if (encodedData && encodedData.length) {
      try {
        data = JSON.parse(Base64.decode(encodedData));
      } catch (error) {
        err = error;
        Raven.captureException(err);
      }
    }
    if (Object.prototype.toString.call(data) === '[object Object]' && data._id) {
      return init(data);
    }
    return $.getJSON(GLOBALS.uris.api + "/survey/data/" + GLOBALS.surveyId).done(function(res) {
      return init(res.data);
    }).fail(function(err) {
      var alert;
      Raven.captureException(err);
      alert = new Alert();
      alert.hideDelayTime = 0;
      alert.type = "error";
      alert.headline = "Unexpected Error";
      alert.message = "Please refresh the page and try again; if that \ndoesn't help <a href='https://surveyplanet.com/contact' \ntarget='_blank'>contact us</a>, we're happy to help.";
      return alert.render();
    });
  });
});

